<app-konto-sektion [titel]="'kontoApiTokens.titel' | translate" [untertitel]="'kontoApiTokens.untertitel' | translate">
  <button
    #anlegenButton
    rechts
    type="button"
    class="kat__primaer"
    data-testid="token-anlegen"
    (click)="dialogOeffnen()"
  >
    <span class="kat__plus" aria-hidden="true">＋</span>
    {{ 'kontoApiTokens.anlegen' | translate }}
  </button>

  <div class="kat__karte">
    <div class="kat__kopf">
      <div class="kat__spalte-token">{{ 'kontoApiTokens.spalten.tokenRechte' | translate }}</div>
      <div class="kat__spalte-ablauf">{{ 'kontoApiTokens.spalten.ablauf' | translate }}</div>
      <div class="kat__spalte-genutzt">{{ 'kontoApiTokens.spalten.zuletztGenutzt' | translate }}</div>
      <div class="kat__spalte-aktion"></div>
    </div>

    @switch (zustand()) {
      @case ('laedt') {
        <div class="kat__laedt">
          <mat-progress-spinner mode="indeterminate" diameter="24" />
        </div>
      }
      @case ('fehler') {
        <div class="kat__fehler" role="alert">
          <span>{{ 'kontoApiTokens.ladefehler' | translate }}</span>
          <button type="button" class="kat__erneut" data-testid="tokens-erneut" (click)="laden()">
            {{ 'kontoApiTokens.erneutVersuchen' | translate }}
          </button>
        </div>
      }
      @default {
        @for (token of tokens(); track token.id) {
          <div class="kat__zeile" data-testid="token-zeile" [attr.data-token-id]="token.id">
            <div class="kat__spalte-token">
              <div class="kat__name">{{ token.name }}</div>
              <div class="kat__pills">
                @for (scope of token.scopes; track scope) {
                  <span class="kat__pill" [class.kat__pill--schreiben]="istSchreibrecht(scope)">
                    {{ scopeLabel(scope) }}
                  </span>
                }
              </div>
            </div>
            <div class="kat__spalte-ablauf kat__ablauf">
              {{ token.expiresAt ? (token.expiresAt | date: 'dd.MM.yyyy') : ('kontoApiTokens.keinAblauf' | translate) }}
            </div>
            <div class="kat__spalte-genutzt kat__genutzt" [class.kat__genutzt--nie]="!token.lastUsedAt">
              {{
                token.lastUsedAt
                  ? (token.lastUsedAt | date: 'dd.MM.yyyy, HH:mm')
                  : ('kontoApiTokens.nieGenutzt' | translate)
              }}
            </div>
            <div class="kat__spalte-aktion">
              <button
                type="button"
                class="kat__papierkorb"
                data-testid="token-widerrufen"
                [attr.title]="'kontoApiTokens.widerrufen' | translate"
                [attr.aria-label]="'kontoApiTokens.widerrufenLabel' | translate: { name: token.name }"
                (click)="widerrufenAnfragen(token)"
              >
                <mat-icon aria-hidden="true">delete_outline</mat-icon>
              </button>
            </div>
          </div>
        } @empty {
          <div class="kat__leer">{{ 'kontoApiTokens.leer' | translate }}</div>
        }
      }
    }
  </div>

  @if (erzeugt(); as neu) {
    <div class="kat__erzeugt" role="status">
      {{ 'kontoApiTokens.erzeugt' | translate: { name: neu.name } }}
      <div class="kat__erzeugt-zeile">
        <code class="kat__token">{{ neu.token }}</code>
        <button
          type="button"
          class="kat__kopieren"
          data-testid="token-kopieren"
          [attr.aria-label]="'kontoApiTokens.kopieren' | translate"
          [attr.title]="'kontoApiTokens.kopieren' | translate"
          (click)="kopieren(neu.token)"
        >
          <mat-icon aria-hidden="true">{{ kopiert() ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </div>
      @if (kopierFehler()) {
        <div class="kat__kopier-fehler" data-testid="token-kopieren-fehler">
          {{ 'kontoApiTokens.kopierenFehler' | translate }}
        </div>
      }
    </div>
  }
</app-konto-sektion>

<app-token-anlegen-dialog
  [offen]="dialogOffen()"
  [busy]="anlegenBusy()"
  [nameFehler]="nameFehler()"
  (anlegen)="anlegen($event)"
  (geschlossen)="dialogGeschlossen()"
/>

@if (rueckfrage(); as ziel) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="kat__overlay" (click)="rueckfrageAbbrechen()">
    <div
      class="kat__rueckfrage"
      role="dialog"
      aria-modal="true"
      aria-labelledby="kat-rueckfrage-titel"
      aria-describedby="kat-rueckfrage-text"
      tabindex="-1"
      cdkTrapFocus
      (click)="$event.stopPropagation()"
      (keydown.escape)="rueckfrageAbbrechen()"
    >
      <div class="kat__rueckfrage-titel" id="kat-rueckfrage-titel">
        {{ 'kontoApiTokens.rueckfrage.titel' | translate: { name: ziel.name } }}
      </div>
      <div class="kat__rueckfrage-text" id="kat-rueckfrage-text">
        {{ 'kontoApiTokens.rueckfrage.text' | translate }}
      </div>
      <div class="kat__fuss">
        <button
          type="button"
          class="kat__sekundaer"
          data-testid="rueckfrage-abbrechen"
          [disabled]="widerrufenBusy()"
          (click)="rueckfrageAbbrechen()"
        >
          {{ 'kontoApiTokens.rueckfrage.abbrechen' | translate }}
        </button>
        <button
          type="button"
          class="kat__gefahr"
          data-testid="rueckfrage-widerrufen"
          [disabled]="widerrufenBusy()"
          (click)="widerrufen()"
        >
          {{ 'kontoApiTokens.rueckfrage.widerrufen' | translate }}
        </button>
      </div>
    </div>
  </div>
}
